import { AxiosInterceptor } from "api/core/consts";

export const companyApi = {
  getCompanies: () => AxiosInterceptor.get('/company'),
  getCompanyList: (paging) => AxiosInterceptor.get('/company' + paging), // 페이징
  getCompany: (companyId) => AxiosInterceptor.get('/company/' + companyId),
  searchCompanies: (paging, body) => AxiosInterceptor.post('/company/search' + paging, body), // 리스트 형식 (전체 불러옴)
  updateUserCompany: (body) => AxiosInterceptor.put('user/company', body),
};
